import React from 'react'
import Header from "../components/headers/light.js"
import Breadcrumb from "components/breadcrumbs/Breadcrumb.jsx";
import { Outlet } from 'react-router-dom';
import tw from "twin.macro";

const ContentContainer = tw.div`pt-24 md:pt-20`;

const LoginLayout = () => {
    return (
        <div>
            <Header />
            <Breadcrumb />
            <ContentContainer>
                <Outlet />
            </ContentContainer>
        </div>
    )
}

export default LoginLayout
